import React from 'react';
import { Card, CardContent } from './ui/card';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

/**
 * FAQ section component with accordion
 * Displays frequently asked questions with structured data
 */
const FAQSection = ({ faqs = [] }) => {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-rabbit mb-6">
              Frequently Asked <span className="text-burnt-coral">Questions</span>
            </h2>
            <p className="text-lg text-rabbit/70">
              Quick answers to common questions about our practice
            </p>
          </div>

          <Card>
            <CardContent className="p-6">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left font-semibold text-rabbit hover:text-burnt-coral">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-rabbit/70">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
